export default "__VITE_ASSET__CuYyYvgd__"